import BulkInput from '@components/BulkInput/BulkInput';
import { LockButton } from '@components/Card2/LockableTextField/LockButton';
import { useCardPopoverBulkInputFocus } from '@hooks/card';
import { Box, Stack, Text } from '@ui-lib';

interface AccreditationsFieldsProps {
  field: string[];
  onChange: (field: string[]) => void;
  valueLocked: boolean;
  valueLockEnabled?: boolean;
  toggleValueLocked?: () => void;
}

const AccreditationsFields: React.FC<React.PropsWithChildren<AccreditationsFieldsProps>> = ({
  field,
  onChange,
  valueLocked,
  valueLockEnabled,
  toggleValueLocked,
}) => {
  const { inputRef } = useCardPopoverBulkInputFocus();

  return (
    <Stack gap="small">
      {valueLockEnabled && (
        <Box display="flex" flexDirection="row" alignItems="center" justifyContent="spaceBetween">
          <Text weight="demibold">Lock Accreditations</Text>
          <LockButton locked={valueLocked} toggleLocked={toggleValueLocked} />
        </Box>
      )}
      <BulkInput
        values={field}
        onChange={onChange}
        placeholders={(index) => `Accreditation #${index + 1}`}
        ref={inputRef}
        locked={valueLocked}
      />
    </Stack>
  );
};

export default AccreditationsFields;
